import { z } from "zod";

export const KlaviyoFlowWebhookRequestPathParamsSchema = z.object({
  shopId: z.string(),
});

export type KlaviyoFlowWebhookRequestPathParamsType = z.infer<
  typeof KlaviyoFlowWebhookRequestPathParamsSchema
>;
